import { createRouter } from '@tanstack/react-router'
import { gtmUrlRewrite } from './gtm-url-rewrite'
import type { QueryClient } from '@tanstack/react-query'
import type { AuthData } from '@/features/auth/hooks/useAuth'
import NotFoundPage from '@/pages/not-found'
import { queryClient } from '@/shared/query'
import { routeTree } from '@/routeTree.gen'

type RouterContext = {
  auth: AuthData
  queryClient: QueryClient
}

const router = createRouter({
  routeTree,
  rewrite: gtmUrlRewrite,
  defaultNotFoundComponent: NotFoundPage,
  context: {
    auth: null as unknown as AuthData,
    queryClient,
  },
  defaultPreload: 'intent',
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

export { router }

export type { RouterContext }
